// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__dTdTL","container":"styles_container__jZNYj","block":"styles_block__S2PRP","link":"styles_link__wINTQ"};